import { useState } from 'react';
import type { KeyboardEvent } from 'react';
import { AxiosResponse } from 'axios';
import { FormattedMessage } from 'react-intl';
import BookingsApi from 'data_system/bookings/api';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';
import { ConfirmEmailModal } from './ConfirmEmailModal';

interface ConfirmEmailResponse {
  email: string;
}

interface ConfirmEmailProps {
  email: string;
  bookingIdHash: string;
  setEmail: (email: string) => void;
}

const ConfirmEmail = ({
  email,
  bookingIdHash,
  setEmail,
}: ConfirmEmailProps) => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleEmailChange = (emailValue: string): void => {
    setIsLoading(true);
    const params = {
      email: emailValue,
    };
    BookingsApi.notifyGuest(bookingIdHash, params)
      .then((response: AxiosResponse<ConfirmEmailResponse>) => {
        if (response && response.status === 200) {
          setEmail(response.data.email);
        }
      })
      .finally(() => {
        setIsEmailModalOpen(false);
        setIsLoading(false);
      });
  };

  return (
    <div id="confirm-email" className="confirm-email">
      <p className="confirm-email-sent-to">
        <FormattedMessage id="SENT_TO" defaultMessage="Sent to" />
      </p>
      <p className="confirm-email-address">{email}</p>
      <button
        type="button"
        className="confirm-email-edit-button brand-color"
        onClick={() => setIsEmailModalOpen(true)}
        onKeyDown={(e: KeyboardEvent) =>
          isActionKey(e.key) && setIsEmailModalOpen(true)
        }
        data-testid="edit-guest-email"
      >
        <FormattedMessage id="EDIT" defaultMessage="Edit" />
      </button>
      <ConfirmEmailModal
        className="confirm-email-modal"
        email={email}
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        onSubmit={handleEmailChange}
        isLoading={isLoading}
      />
    </div>
  );
};

export default ConfirmEmail;
